import { CREATE_FOLDER } from '../../constants';

const initialState = {
  data: {},
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case CREATE_FOLDER.LOAD:
      return {
        ...state,
        loading: true,
      };
    case CREATE_FOLDER.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case CREATE_FOLDER.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
